// The box that ticks a task, in the colours of the admin's checkboxes. It
// keeps its click from opening the row it sits in.
const TaskCheckbox = ({ checked, disabled = false, label, onToggle }) => (
  <span className="flex" onClick={(event) => event.stopPropagation()}>
    <input
      type="checkbox"
      className="checkbox-primary"
      checked={checked}
      disabled={disabled}
      onChange={onToggle}
      aria-label={label}
    />
  </span>
);

export default TaskCheckbox;
